/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountSelector_viewer = {
    readonly user: {
        readonly id: string;
        readonly username: string;
        readonly roles: ReadonlyArray<{
            readonly name: string;
        }>;
    } | null;
    readonly " $refType": "AccountSelector_viewer";
};
export type AccountSelector_viewer$data = AccountSelector_viewer;
export type AccountSelector_viewer$key = {
    readonly " $data"?: AccountSelector_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountSelector_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountSelector_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '10de32e55bc53c93bac3736ed044f556';
export default node;
